import { Variants } from 'motion/react';

export const easings = {
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
};

export const markdownArticleContainerMotion: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      staggerDirection: 1,
    },
  },
  exit: {
    opacity: 0,
  },
};

export const markdownArticleChildMotion: Variants = {
  initial: {
    x: 20,
    opacity: 0,
  },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 1.2,
      ease: 'easeInOut',
    },
  },
};

export const textRevealMotion = (delay: number) => {
  return {
    initial: { x: 100, opacity: 0 },
    animate: {
      x: 0,
      opacity: 1,
      transition: { delay: 0.4 + delay, duration: 0.8, ease: easings.easeOutQuart },
    },
  };
};

export const dividerMotion = {
  initial: {
    scaleX: 0,
  },
  hover: {
    scaleX: 1,
    transition: {
      duration: 0.8,
      ease: easings.easeInOutQuint,
    },
  },
  exit: {
    transition: {
      scaleX: 0,
      duration: 0.4,
      ease: easings.easeInOutQuint,
    },
  },
};

export const arrowMotion = {
  initial: {
    opacity: 0,
  },
  hover: {
    transition: {
      type: 'spring',
      bounce: 0.5,
      duration: 0.5,
    },
  },
};

export const overlayMenuItemMotion = {
  hover: {
    transition: { type: 'spring', bounce: 0.5, duration: 0.5 },
  },
};

export const scaleMotion = {
  initial: { scale: 0, x: '-50%', y: '-50%' },
  open: { scale: 1, x: '-50%', y: '-50%', transition: { duration: 0.4, ease: [0.76, 0, 0.24, 1] } },
  closed: { scale: 0, x: '-50%', y: '-50%', transition: { duration: 0.4, ease: [0.32, 0, 0.67, 0] } },
};

export const pageNavigationMotion: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 2, ease: easings.easeOutQuart } },
  exit: { opacity: 0 },
};
